export default {
  colors: {
    primary: '#B50D16',
    accent: '#F09D00',
    success: '#0DB5AD',
    error: '#DE0000'
  }
};
